<div class="atp-dynamic-form__container">
  <atp-title class="atp-dynamic-form__title" [text]="data.title" afterIcon="shuffle" notSetInHeader="false">
  </atp-title>

  <div mat-dialog-content class="atp-dynamic-form__content">
    <button mat-button class="atp-movement-popup__button atp-movement-popup__button_root"
      [color]="dataSource.selectedNodeId === null ? 'primary' : 'basic'" (click)="nodeSelectClick(null)">
      <mat-icon class="atp-movement-popup__button-internal-icon">folder</mat-icon>{{data.rootName}}
    </button>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <mat-icon>folder</mat-icon>
        <button mat-button style="min-width: 0;" [color]="node.isSelected ? 'primary' : 'basic'"
          (click)="nodeSelectClick(node.id)">
          {{node.name}}
        </button>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <mat-icon>folder</mat-icon>
        <button mat-button style="min-width: 0;" [color]="node.isSelected ? 'primary' : 'basic'"
          (click)="nodeSelectClick(node.id)">
          {{node.name}}
        </button>
        <mat-progress-bar *ngIf="node.isLoading" mode="indeterminate" style="margin-left: 10px;"></mat-progress-bar>
      </mat-tree-node>
    </mat-tree>
  </div>

  <div mat-dialog-actions class="atp-dynamic-form__actions">
    <button mat-raised-button class="atp-dynamic-form__actions-button atp-dynamic-form__actions-button_submit"
      color="primary" [disabled]="dataSource.selectedNodeId === undefined" (click)="submit()">Переместить</button>
    <button mat-raised-button class="atp-dynamic-form__actions-button atp-dynamic-form__actions-button_close"
      (click)="close()">Отмена</button>
  </div>
</div>